import { render, staticRenderFns } from "./UserSleepData.vue?vue&type=template&id=66772868&scoped=true&"
import script from "./UserSleepData.vue?vue&type=script&lang=js&"
export * from "./UserSleepData.vue?vue&type=script&lang=js&"
import style0 from "./UserSleepData.vue?vue&type=style&index=0&id=66772868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66772868",
  null
  
)

export default component.exports